<ion-menu side="end" contentId="main" [appHideScrollbar] menuId="omnisettingsmenu">
    <div dcBgColor="dialog-bg" class="flex h-full flex-col overflow-y-auto">
        <div class="flex items-center space-x-4 px-4 pt-safe-offset-4">
            <app-option-button icon="settings" [clickable]="false"></app-option-button>
            <div dcTypography="bulevar-32" [translate]="'ADVANCED'" i18n="@@ADVANCED">Advanced</div>
        </div>

        @if (selectedOmni()) {
            <div class="mt-4 space-y-0">
                @if (isAdmin()) {
                    <div>
                        <div
                            dcBgColor="flight-blue-3"
                            dcTypography="bulevar-24"
                            dcColor="dark-treble-green-2"
                            class="px-4 py-2"
                            [translate]="'GENERAL'"
                            i18n="@@GENERAL">
                            General
                        </div>
                        <div class="divide-y-1 divide-divider-color">
                            <div
                                dcBgColor="form-control-bg"
                                class="dc-surface-page flex w-full items-center justify-between px-4 py-2">
                                <div
                                    dcTypography="geist-14-semibold"
                                    dcColor="dark-treble-green-2"
                                    [translate]="'SHARE_WITH_FRIENDS'"
                                    i18n="@@SHARE_WITH_FRIENDS">
                                    Share with friends
                                </div>
                                <button
                                    dcButton
                                    type="button"
                                    size="small"
                                    (click)="shareOmni()"
                                    dcBgColor="oche-orange-fixed"
                                    [translate]="'SHARE'"
                                    i18n="@@SHARE">
                                    Share
                                </button>
                            </div>
                        </div>
                        <div
                            dcBgColor="flight-blue-3"
                            dcTypography="bulevar-24"
                            dcColor="dark-treble-green-2"
                            class="px-4 py-2"
                            [translate]="'TROUBLESHOOT'"
                            i18n="@@TROUBLESHOOT">
                            Troubleshoot
                        </div>
                        <div class="divide-y-1 divide-divider-color">
                            <div
                                dcBgColor="form-control-bg"
                                class="dc-surface-page flex w-full items-center justify-between px-4 py-2">
                                <div
                                    dcBgColor="form-control-bg"
                                    dcTypography="geist-14-semibold"
                                    dcColor="dark-treble-green-2"
                                    [translate]="'REPAIR_DEVICE'"
                                    i18n="@@REPAIR_DEVICE">
                                    Repair device
                                </div>
                                <button
                                    dcButton
                                    type="button"
                                    size="small"
                                    (click)="repairOmni()"
                                    dcBgColor="oche-orange-fixed"
                                    [translate]="'REPAIR'"
                                    i18n="@@REPAIR">
                                    Repair
                                </button>
                            </div>

                            @if (!isWeb && currentConnectionStatus() === ConnectionStatus.CONNECTED) {
                                <div
                                    dcBgColor="form-control-bg"
                                    class="flex w-full items-center justify-between px-4 py-2">
                                    <div
                                        dcTypography="geist-14-semibold"
                                        dcColor="dark-treble-green-2"
                                        [translate]="'CALIBRATION_IMAGES'"
                                        i18n="@@CALIBRATION_IMAGES">
                                        Calibration images
                                    </div>
                                    <button
                                        dcButton
                                        type="button"
                                        size="small"
                                        (click)="openCalibrationImages()"
                                        dcBgColor="oche-orange-fixed"
                                        [translate]="'OPEN'"
                                        i18n="@@OPEN">
                                        Open
                                    </button>
                                </div>
                            }
                        </div>

                        <div
                            dcBgColor="flight-blue-3"
                            dcTypography="bulevar-24"
                            dcColor="dark-treble-green-2"
                            class="px-4 py-2"
                            [translate]="'BETA'"
                            i18n="@@BETA">
                            Beta
                        </div>
                        <div class="divide-y-1 divide-divider-color">
                            <app-toggle-switch
                                dcBgColor="form-control-bg"
                                class="block w-full px-4 py-2"
                                [model]="isBeta()"
                                (itemChange)="promptBeta()">
                                <div
                                    dcTypography="geist-14-semibold"
                                    dcColor="dark-treble-green-2"
                                    [translate]="'BETA_TESTER'"
                                    i18n="@@BETA_TESTER">
                                    Beta tester
                                </div>
                            </app-toggle-switch>
                        </div>

                        @if (isTester()) {
                            <div
                                dcBgColor="flight-blue-3"
                                dcTypography="bulevar-24"
                                dcColor="dark-treble-green-2"
                                class="px-4 py-2">
                                TESTERS
                            </div>
                            <div dcBgColor="form-control-bg" class="dc-surface-page divide-y-1 divide-divider-color">
                                <app-toggle-switch
                                    class="block w-full px-4 py-2"
                                    [model]="firmwareSettings().saveAllImages"
                                    (itemChange)="toggleSaveAllImages($event)">
                                    <div dcTypography="geist-14-semibold" dcColor="dark-treble-green-2">
                                        Save all images
                                    </div>
                                </app-toggle-switch>
                            </div>
                            <div dcBgColor="form-control-bg" class="dc-surface-page divide-y-1 divide-divider-color">
                                <app-toggle-switch
                                    class="block w-full px-4 py-2"
                                    [model]="firmwareSettings().saveToArchive"
                                    (itemChange)="toggleSaveToArchive($event)">
                                    <div dcTypography="geist-14-semibold" dcColor="dark-treble-green-2">
                                        Save to archive
                                    </div>
                                </app-toggle-switch>
                            </div>
                        }

                        @if (isDev()) {
                            <div
                                dcBgColor="flight-blue-3"
                                dcTypography="bulevar-24"
                                dcColor="dark-treble-green-2"
                                class="px-4 py-2">
                                DEVELOPERS
                            </div>
                            <div class="divide-y-1 divide-divider-color">
                                <app-toggle-switch
                                    dcBgColor="form-control-bg"
                                    class="block w-full px-4 py-2"
                                    [model]="firmwareSettings().saveAllImages"
                                    (itemChange)="toggleSaveAllImages($event)">
                                    <div
                                        dcBgColor="form-control-bg"
                                        dcTypography="geist-14-semibold"
                                        dcColor="dark-treble-green-2">
                                        Save game images
                                    </div>
                                </app-toggle-switch>
                                <app-toggle-switch
                                    class="block w-full px-4 py-2"
                                    [model]="firmwareSettings().saveToArchive"
                                    (itemChange)="toggleSaveToArchive($event)">
                                    <div dcTypography="geist-14-semibold" dcColor="dark-treble-green-2">
                                        Save calibration images
                                    </div>
                                </app-toggle-switch>
                                <div
                                    dcBgColor="form-control-bg"
                                    class="flex w-full items-center justify-between px-4 py-2">
                                    <div
                                        dcBgColor="form-control-bg"
                                        dcTypography="geist-14-semibold"
                                        dcColor="dark-treble-green-2">
                                        Change firmware
                                    </div>
                                    <button
                                        dcButton
                                        size="small"
                                        (click)="changeFirmware()"
                                        type="button"
                                        dcBgColor="oche-orange-fixed">
                                        Change
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="flex px-4 py-2 text-center">
                        <div
                            class="w-full p-4"
                            dcBgColor="card-bg"
                            [translate]="'YOURE_NOT_THE_OWNER_OF_THIS_DEVICE_NOTICE'"
                            i18n="@@YOURE_NOT_THE_OWNER_OF_THIS_DEVICE_NOTICE">
                            You are not the owner of this device, so you have less advanced settings. If you want to
                            check for updates or other advanced settings, contact the person that invited you to use
                            this device.
                        </div>
                    </div>
                }

                <div class="px flex w-full items-center justify-evenly py-4" dcTypography="geist-14-semibold">
                    @if (!isWeb || versionHelper.isVersionSameOrAbove(selectedOmni().firmware?.version_key, '1.1.0')) {
                        <button
                            type="button"
                            dcColor="dark-treble-green"
                            class="flex w-full flex-row items-center justify-center space-x-1.5"
                            (click)="rebootOmni()">
                            <app-icon icon="power_settings_new"></app-icon>
                            <span [translate]="'REBOOT'" i18n="@@REBOOT">Reboot</span>
                        </button>
                    }

                    <button
                        type="button"
                        dcColor="bullseye-red-fixed"
                        class="flex w-full flex-row items-center justify-center space-x-1.5"
                        (click)="removeOmni()">
                        <app-icon icon="close"></app-icon>
                        <span [translate]="'REMOVE'" i18n="@@REMOVE">Remove</span>
                    </button>
                </div>
            </div>
        }
    </div>
</ion-menu>
